// extracted by mini-css-extract-plugin
export var baseButton = "_pe-0";
export var controlsArrowKeys = "_pe-1";
export var controlsResetButton = "_pe-2";
export var lightGameButton = "_pe-4 _pe-0";
export var playAgainButton = "_pe-5 _pe-0";
export var startGameButton = "_pe-3 _pe-0";